import React, {FC, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Button, Label, Alert} from 'reactstrap';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import {actions} from "~/state/reducers/term-reducer.ts";
import {confirm as dConfirm} from '../../utils/confirm-util.ts';

interface ComponentProps {
    forceModalOpen: () => void;
}

export const TermsForceImport: FC<ComponentProps> = ({forceModalOpen}: ComponentProps) => {
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isImportClicked, setIsImportClicked] = useState(null);

    const validateDateInput = dateInput => dateInput !== null && dateInput !== '';

    const forceImport = () => {
        const maxYearSpan = 5;
        if (!isImportClicked) {
            setIsImportClicked(() => true);
        }

        if (!validateDateInput(startDate)) {
            return;
        }

        if (validateDateInput(startDate) && validateDateInput(endDate)
            && endDate.valueOf() < startDate.valueOf()) {
            return;
        }

        if (validateDateInput(endDate) && endDate.year() - startDate.year() >= maxYearSpan) {
            dConfirm('', {
                cancelLabel: 'Cancel',
                okLabel: 'Yes, I\'m sure',
                message: 'This date range may take a long time to load.',
                title: 'Import Terms Date Range',
            })
                .then(() => {
                    forceModalOpen();
                    const payload = {
                        application: 'OTC',
                        endDateMillis: endDate.valueOf(),
                        startDateMillis: startDate.valueOf(),
                    };
                    dispatch(actions.forceImportTerms(payload))
                });
        } else {
            forceModalOpen();
            const payload = {
                application: 'OTC',
                endDateMillis: endDate === null ? null : endDate.valueOf(),
                startDateMillis: startDate.valueOf(),
            };
            dispatch(actions.forceImportTerms(payload));
        }
    };

    const changeStartDate = moment => {
        setStartDate(() => moment);
    };

    const changeEndDate = moment => {
        setEndDate(() => moment);
    };

    const searchErrorEndDateLessThanStartDate = Boolean(validateDateInput(startDate)
        && validateDateInput(endDate)
        && endDate.valueOf() < startDate.valueOf());

    return (
        <React.Fragment>
            <form className="form-inline">
                <div className="form-group mb-3">
                    <Label for="startDate" className="d-inline-block mr-3">Start Date</Label>
                    <Datetime
                        className="startDate"
                        value={startDate}
                        onChange={changeStartDate}
                        timeFormat={false}
                        input
                        inputProps={{placeholder: 'MM/DD/YYYY'}}
                    />
                </div>
                <div className="form-group mb-3">
                    <Label for="endDate" className="d-inline-block ml-3 mr-3">End Date</Label>
                    <Datetime
                        className="endDate"
                        value={endDate}
                        onChange={changeEndDate}
                        timeFormat={false}
                        input
                        inputProps={{placeholder: 'MM/DD/YYYY'}}
                    />
                </div>
                <div className="form-group mb-3 ml-3">
                    <Button
                        color="primary"
                        onClick={forceImport}
                    >
                        Import
                    </Button>
                </div>
            </form>

            <Alert color="danger" isOpen={isImportClicked && !validateDateInput(startDate)}>
                {'The Start Date is required. Please try again.'}
            </Alert>
            <Alert color="danger" isOpen={isImportClicked && searchErrorEndDateLessThanStartDate}>
                {'The End Date needs to be greater than the Start Date.'}
            </Alert>

        </React.Fragment>
    );
}

export default TermsForceImport;
